module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form container"
  }, [_c('div', {
    staticClass: "form-article formResponsive formHorizontal"
  }, [_c('div', {
    staticClass: "form-article-item form-article-item-approved"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "review-approved-yes"
    }
  }, [_c('input', {
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "id": "review-approved-yes",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.review.approved,
      "checked": _vm.review.approved
    },
    on: {
      "input": function($event) {
        _vm.review.approved = true
      }
    }
  }), _vm._v("\n        Approved\n        "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "container2",
    attrs: {
      "for": "review-approved-no"
    }
  }, [_c('input', {
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "id": "review-approved-no",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.review.approved,
      "checked": !_vm.review.approved
    },
    on: {
      "input": function($event) {
        _vm.review.approved = false
      }
    }
  }), _vm._v("\n        Not Approved\n        "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item form-article-item-corrections"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "review-corrections-yes"
    }
  }, [_c('input', {
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "id": "review-corrections-yes",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.review.corrections,
      "checked": _vm.review.corrections
    },
    on: {
      "input": function($event) {
        _vm.review.corrections = true
      }
    }
  }), _vm._v("\n        With corrections\n        "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "container2",
    attrs: {
      "for": "review-corrections-no"
    }
  }, [_c('input', {
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "id": "review-corrections-no",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.review.corrections,
      "checked": !_vm.review.corrections
    },
    on: {
      "input": function($event) {
        _vm.review.corrections = false
      }
    }
  }), _vm._v("\n        Without corrections\n        "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item form-article-item-text"
  }, [(!_vm.disabled) ? _c('wysiwyg', {
    staticClass: "text-editor",
    model: {
      value: (_vm.review.text),
      callback: function($$v) {
        _vm.$set(_vm.review, "text", $$v)
      },
      expression: "review.text"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.disabled) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.review.text),
      expression: "review.text"
    }],
    staticClass: "text-editor",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.review.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.review, "text", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "footer"
  }, [_vm._v("\n        Obligatory in case of non approval or approval with corrections; these\n        notes will be e-mailed to the author. Máx 2000 carat.\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40928dd7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReviewForm.vue
// module id = 162
// module chunks = 2